import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function ProfileSetup() {
  const { setupProfile } = useAuth();
  const navigate = useNavigate();
  const [displayName, setDisplayName] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!displayName.trim()) {
      setError('Please enter your name');
      return;
    }

    setLoading(true);
    setError('');

    try {
      await setupProfile(displayName.trim());
      navigate('/', { replace: true });
    } catch (err) {
      setError(err.response?.data?.detail || 'Failed to setup profile');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="mobile-container min-h-screen flex flex-col items-center justify-center px-6 bg-bone">
      <div className="w-full max-w-sm">
        <h1 className="text-4xl font-black font-heading uppercase tracking-tight text-graphite mb-2">
          Welcome to BRETH
        </h1>
        <p className="text-base text-graphite/80 mb-8">
          What should your training partner call you?
        </p>

        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label
              htmlFor="displayName"
              className="block text-xs uppercase tracking-[0.2em] font-semibold text-graphite/60 mb-2"
            >
              Display Name
            </label>
            <input
              id="displayName"
              type="text"
              value={displayName}
              onChange={(e) => setDisplayName(e.target.value)}
              required
              maxLength={50}
              className="w-full h-14 px-4 border border-hairline bg-bone text-graphite text-base font-body focus:outline-none focus:ring-2 focus:ring-graphite"
              placeholder="Your name"
              autoFocus
              data-testid="display-name-input"
            />
          </div>

          {error && (
            <div className="p-4 border border-userRed bg-userRed/5 text-userRed text-sm">
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            className="w-full h-16 bg-userRed text-bone font-black text-base uppercase tracking-wider transition-opacity hover:opacity-90 disabled:opacity-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-graphite"
            data-testid="continue-button"
          >
            {loading ? 'Setting up...' : 'Continue'}
          </button>
        </form>
      </div>
    </div>
  );
}
